import React from "react";
import AboutHero from "./AboutHero";

export default function About() {
  return (
    <>
      <AboutHero />
    </>
  );
}
